const DOCUMENT = 'TALENT_BACKGROUND_CHECKS_';

const actions = {
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CHANGE_EDIT_FORM_PROPERTY: DOCUMENT + 'CHANGE_EDIT_FORM_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE_BACKGROUND_CHECK: DOCUMENT + 'CREATE_BACKGROUND_CHECK',
  CREATE_BACKGROUND_CHECK_ERROR: DOCUMENT + 'CREATE_BACKGROUND_CHECK_ERROR',
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  REORDER_BACKGROUND_CHECK: DOCUMENT + 'REORDER_BACKGROUND_CHECK',
  REORDER_BACKGROUND_CHECK_ERROR: DOCUMENT + 'REORDER_BACKGROUND_CHECK_ERROR',
  CLEAR_MODAL: DOCUMENT + 'CLEAR_MODAL',
  SUBMIT_MANUALLY_BACKGROUND_CHECK_REQUEST: DOCUMENT + 'SUBMIT_MANUALLY_BACKGROUND_CHECK_REQUEST',
  TOGGLE_BACKGROUND_CHECKS_MODAL: DOCUMENT + 'TOGGLE_BACKGROUND_CHECKS_MODAL',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',

  saveError: data => ({
    type: actions.SAVE_ERROR,
    payload: data,
  }),

  toggleBackgroundCheckModal: () => ({
    type: actions.TOGGLE_BACKGROUND_CHECKS_MODAL,
  }),

  changeProperty: payload => ({
    type: actions.CHANGE_PROPERTY,
    payload,
  }),

  changeEditFormProperty: payload => ({
    type: actions.CHANGE_EDIT_FORM_PROPERTY,
    payload,
  }),

  clearStore: payload => ({
    type: actions.CLEAR_STORE,
    payload,
  }),

  createBackgroundCheck: payload => ({
    type: actions.CREATE_BACKGROUND_CHECK,
    payload,
  }),

  createBackgroundCheckError: payload => ({
    type: actions.CREATE_BACKGROUND_CHECK_ERROR,
    payload,
  }),

  loadData: payload => ({
    type: actions.LOAD_REQUEST,
    payload,
  }),

  loadDataSuccess: payload => ({
    type: actions.LOAD_SUCCESS,
    payload,
  }),

  reorderBackgroundCheck: payload => ({
    type: actions.REORDER_BACKGROUND_CHECK,
    payload,
  }),

  reorderBackgroundCheckError: payload => ({
    type: actions.REORDER_BACKGROUND_CHECK_ERROR,
    payload,
  }),

  clearModal: () => ({
    type: actions.CLEAR_MODAL,
  }),

  submitManuallyBackgroundCheck: data => ({
    type: actions.SUBMIT_MANUALLY_BACKGROUND_CHECK_REQUEST,
    payload: data,
  }),
};

export default actions;
